import type { DecisionMakerResponsePageState } from './types';

export const INITIAL_STATE: DecisionMakerResponsePageState = {
	beforeSuggestedPetitions: true,
};
